import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=a912773e&scoped=true"
import script from "./ModalProduct.vue?vue&type=script&lang=ts"
export * from "./ModalProduct.vue?vue&type=script&lang=ts"
import style0 from "./ModalProduct.vue?vue&type=style&index=0&id=a912773e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a912773e",
  null
  
)

export default component.exports